/**
 * Configure to what is available to use in this repo
 */

export const analyticsConfig = {
  mixpanel: true,
  webengage: true,
  "event-logger": true,
};
